import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { app } from '../../config';
import { useNavigate } from 'react-router-dom';
import { Pagination, Input, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { dateConverter } from '../../utils/utcDateConversion';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';
import NoRecordFound from '../../components/common/NoRecordFound';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function RecurrCancelRequest() {
  const { t } = useTranslation(['common']);
  let { Search } = Input;
  let navigate = useNavigate();
  let users;
  let searchedUser;
  const [editbtn, setEditBtn] = useState('none');
  const [search, setSearch] = useState('');
  const [current, setCurrent] = useState(1);
  const [cancelRecurr, setFetchCancelRecurr] = useState([]);
  const [pagesCount, setPagesCount] = useState(0);
  const [cancelQueryRes, setCancelQueryRes] = useState(false);
  const [searchShow, setSearchShow] = useState(false);
  const [renderList, setRenderList] = useState();
  const [tableShow, setTableShow] = useState(true);
  const [err, setErr] = useState('');
  const [recurrReqRes, setRecurrReqRes] = useState();
  const [show, setShow] = useState(false);
  const [reqObj, setReqObj] = useState({});
  const user = JSON.parse(localStorage.getItem('user'));
  const token = getTokenfromUserObj();
  console.log(token);
  useEffect(() => {
    const userList = async () => {
      const user = JSON.parse(localStorage.getItem('user'));
      if (user.userType === 'A') setEditBtn('block');
      const limit = 1000;
      const offset = 0;
      const recurrCancelRequestResp = await axios.post(`${app.URL}/cancelrequest/viewall${(user.userType === 'O' && user?.organizationId) ? `?organizationId=${user.organizationId}`:''}`, {}, { headers: { auth: token } });
      let convertedObj = dateConverter(recurrCancelRequestResp.data.data, 'createdOn');
      convertedObj = dateConverter(recurrCancelRequestResp.data.data, 'startDate');
      console.log('��� ~ file: Users.js:31 ~ userList ~ convertedObj', convertedObj);
      recurrCancelRequestResp.data ? setFetchCancelRecurr(convertedObj) : ' ';
      recurrCancelRequestResp.data ? setPagesCount(convertedObj.length) : ' ';
      recurrCancelRequestResp.data ? setRenderList(convertedObj.slice(0, 10)) : ' ';
      recurrCancelRequestResp.data ? setCancelQueryRes(false) : ' ';
    };
    userList();
  }, [cancelQueryRes]);
  const handleSearch = async () => {
    console.log('calling');
    try {
      const result = search ? await axios.get(`${app.URL}/user/search/${search}`) : [];
      console.log(result);
      searchedUser = result.data.data;
    } catch (e) {
      console.log('Error');
      if (e.message) setErr(e.response.data.message);
      setTableShow(false);
    }

    console.log(searchedUser);
    if (searchedUser) {
      setSearchShow(true);
      setRenderList(searchedUser);
    }
    console.log(searchedUser);
  };
  const handleClose = () => setShow(false);
  const onSearch = async (value) => {
    console.log(value);
    try {
      const result = await axios.get(`${app.URL}/user/search/${value}`, { headers: { auth: token } });
      console.log(result);
      searchedUser = result.data.data;
      setRenderList(searchedUser);
      setPagesCount(searchedUser.length);
    } catch (e) {
      console.log('Error');
      if (e.message) setErr(e.response.data.message);
      setTableShow(false);
    }
  };
  const onChange = async (page, pageSize) => {
    console.log(page);
    setCurrent(page);
    if (!page) page = 1;
    let limit = pageSize;
    let reqObj = {
      limit,
      offset: limit * (page - 1),
    };
    setRenderList(cancelRecurr.slice(reqObj.offset, reqObj.offset + limit));
    console.log(renderList);
  };
  const cancelRecurringTrigger = (payload) => {
    console.log(payload);

    let requestObj = {
      donorId: payload.donorId,
      recurringId: payload.recurringId,
      organizationId: payload.organizationId,
      contractId: payload.mxRecurrContractId,
    };
    setReqObj(requestObj);
    setShow(true);
  };
  console.log(reqObj);
  const cancelContract = async () => {
    console.log(reqObj);
    try {
      let cancelContractQuery = `${app.URL}/merchantportal/cancelcontract`;
      const queryResponse = await axios.post(cancelContractQuery, reqObj, { headers: { auth: token } });
      console.log(queryResponse);
      setRecurrReqRes(queryResponse);
      setShow(false);
      console.log(queryResponse.message);
      message.success(queryResponse.message ? queryResponse.message : 'Recurring Contract Cancelled successfully');
      // setTimeout(()=>{
      //   setShow(false)
      // },3000)
      setCancelQueryRes(true);
    } catch (err) {
      setShow(false);
      message.error('Recurring cancellation failed');
    }
  };
  const handleSearchChange = (e) => {
    console.log(e.target.value);
    if (!e.target.value) {
      setRenderList(cancelRecurr.slice(0, 10));
      //  console.log(organizations.length)
      setPagesCount(cancelRecurr.length);
      setTableShow(true);
    }
    setSearch(e.target.value);
  };

  const editKiosk = (e) => {
    console.log(e);
    localStorage.setItem('kioskId', JSON.stringify(e.kioskId));
    navigate('/kiosk/edit', { replace: true });
  };
  const addKiosk = () => {
    navigate('/kiosk/add', { replace: true });
  };
  console.log(renderList);

  return (
    <div className='ml-3 col-lg-12 col-md-12 col-sm-12 '>
      <div className='row text-center'>
        <div className='col-lg-11 mt-4'>
          <Search
            className='search'
            placeholder='input search text'
            onChange={handleSearchChange}
            onSearch={onSearch}
            style={{
              width: 300,
            }}
          />
        </div>
      </div>
      <div className='row mt-2'>
        <div className='col-lg-10 col-md-10 col-sm-10 fs-3 fw-bold'>{t('Recurring Cancellation Requests')}</div>
        {/* <div className="col-lg-2 col-md-2 col-sm-2">
        <button class="btn btn-primary button" onClick={addKiosk}>Add</button>  
        </div>   */}
      </div>
      <div className='col-lg-11 col-md-12 col-sm-12 '>
        <div class=' styled-table '>
          <table class='table text-black'>
            <thead class='thead-light'>
              <tr>
                <th>{t('Organization')}</th>
                <th>{t('Reference No.')}</th>
                <th>{t('Donor Name')}</th>
                <th>{t('Cause')}</th>
                <th>{t('Start Date')}</th>
                <th>{t('Interval')}</th>
                <th>{t('Occurrences')}</th>
                <th>{t('Status')}</th>
                <th> </th>
                {/* <th> </th> */}
              </tr>
            </thead>
            <tbody>
              {renderList
                ? renderList.map((output) => (
                    <tr className='row-hover'>
                      <td style={{ width: '250px' }}>{output.organizationName}</td>
                      <td style={{ width: '160px' }}>{output.mxRecurrContractId}</td>
                      <td style={{ width: '200px' }}>{output.donorName}</td>
                      <td style={{ width: '160px' }}>{output.causeName}</td>
                      <td style={{ width: '200px' }}>{output.startDate}</td>
                      <td style={{ width: '120px' }}>{output.paymentInterval}</td>
                      <td style={{ width: '50px' }}>{output.occurrences ? output.occurrences : 'Unlimited'}</td>
                      <td style={{ width: '70px' }}>{output.recurringStatus}</td>
                      {/* <td style={{width:"160px"}}>{output.model}</td> */}

                      {/* <td style={{width:"200px"}}>{output.createdOn}</td> */}
                      <td style={{ width: '70px' }}>
                        {output.requestStatus == 'Completed' ? (
                          ' '
                        ) : (
                          <button class='btn btn-primary button' style={{ fontSize: '13px' }} onClick={() => cancelRecurringTrigger(output)}>
                            Cancel
                          </button>
                        )}
                        {/* <EditTwoTone displayName="edit" twoToneColor="blue" style={{fontSize:"20px"}} onClick={()=>{editKiosk(output)}} /> */}
                        {/* <button type='button' style={{ display: editbtn }} class='btn btn-primary color1 button' onClick={() => editOrg(output)}>
                         {t('Edit')}
                       </button> */}
                      </td>
                    </tr>
                  ))
                : ' '}
            </tbody>
          </table>
          {recurrReqRes && recurrReqRes.statusCode === 200 ? (
            <Modal show={show} onHide={handleClose}>
              <Modal.Header closeButton>
                <Modal.Title className='text-center'>Success</Modal.Title>
              </Modal.Header>
              <Modal.Body>{recurrReqRes.message}</Modal.Body>
              <Modal.Footer></Modal.Footer>
            </Modal>
          ) : recurrReqRes && recurrReqRes.statusCode === 400 ? (
            <Modal show={show} onHide={handleClose}>
              <Modal.Header closeButton>
                <Modal.Title className='text-center'>Failed</Modal.Title>
              </Modal.Header>
              <Modal.Body>{recurrReqRes.data.message}</Modal.Body>
              <Modal.Footer></Modal.Footer>
            </Modal>
          ) : (
            <Modal show={show} onHide={handleClose}>
              <Modal.Header closeButton>
                <Modal.Title>Confirmation</Modal.Title>
              </Modal.Header>
              <Modal.Body>Are you sure you want to cancel a contract?</Modal.Body>
              <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                  Cancel
                </Button>
                <Button variant='primary' htmlType='submit' onClick={cancelContract}>
                  Confirm
                </Button>
              </Modal.Footer>
            </Modal>
          )}
          {renderList && renderList.length == 0 ? <NoRecordFound /> : ' '}
        </div>
      </div>
      <Pagination style={{ marginTop: '10px' }} onChange={onChange} defaultCurrent={current} pageSize={10} total={pagesCount} />
    </div>
    //     </div>
    //   </div>
    // </div>
  );
}

export default RecurrCancelRequest;
